export class AdminOptionCategory {
    public WebCategoryId: number;
    public WebCategoryDesc: string;

    constructor() {

    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/admin-option-category.ts